import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const SessionTimeout = ({ showModal, handleClose, handleLogout }) => {
  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      aria-labelledby="timeout"
      aria-describedby="timeoutDescription"
    >
      <DialogTitle id="timeout">{"You Have Been Idle!"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="timeout">
          You Will Get Timed Out. You want to stay?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleLogout} color="primary">
          Logout
        </Button>
        <Button onClick={handleClose} color="primary" autoFocus>
          Stay
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SessionTimeout;